import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SENSE_OPTIONS,
  SenseFeature, 
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

type Props = {
  obj: SenseFeature;
  onChange: (changed: SenseFeature) => void; 
  disabled: boolean;
}

export interface State { 
}

class SenseFeatureInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      senses: [],
      loading: true
    };
  }

  render() {
    return (
      <Grid container spacing={0} direction="column">
        <Grid>
          <SelectStringBox
            name="Sense"
            options={SENSE_OPTIONS}
            value={this.props.obj.sense_id}
            disabled={this.props.disabled}
            onChange={(id: string) => {
              this.props.obj.sense_id = id;
              this.props.onChange(this.props.obj);
            }}
          />
        </Grid>
        <Grid>
          <StringBox
            name="Range"
            value={`${this.props.obj.range}`}
            type="number"
            disabled={this.props.disabled}
            onBlur={(changed: string) => {
              this.props.obj.range = +changed;
              this.props.onChange(this.props.obj);
            }}
          />
        </Grid>
        <Grid>
          <StringBox
            name="Or Add"
            value={`${this.props.obj.or_add}`}
            type="number"
            disabled={this.props.disabled}
            onBlur={(changed: string) => {
              this.props.obj.or_add = +changed;
              this.props.onChange(this.props.obj);
            }}
          />
        </Grid>
      </Grid>
    );
  }
}

export default SenseFeatureInput;
